/**
 * useKonamiCode - Hook to detect Konami code sequence
 * Sequence: ↑ ↓ ↑ ↓ A B
 */

import { useEffect, useRef, useCallback } from 'react';
import { KONAMI_CODE } from '../types/game';

export function useKonamiCode(onActivate: () => void): void {
  const keySequence = useRef<string[]>([]);

  const handleKeyDown = useCallback((event: KeyboardEvent) => {
    // Add the key to the sequence
    keySequence.current.push(event.code);

    // Keep only the last N keys where N is the length of the Konami code
    if (keySequence.current.length > KONAMI_CODE.length) {
      keySequence.current.shift();
    }

    // Check if the sequence matches
    if (keySequence.current.length === KONAMI_CODE.length) {
      const matches = KONAMI_CODE.every(
        (key, index) => keySequence.current[index] === key
      );

      if (matches) {
        onActivate();
        keySequence.current = []; // Reset after activation
      }
    }
  }, [onActivate]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);
}
